import { ButtonTheme } from '@/components/Button/theme';
import { GenericSlot } from 'base/components/GenericSlot';
import { Spinner as StandaloneSpinner } from '@/components/Spinner';

const ButtonBase = GenericSlot({ as: 'button', theme: ButtonTheme });
const Spinner = GenericSlot({ as: StandaloneSpinner, theme: ButtonTheme.Spinner });

export const Button = Object.assign(ButtonBase, { Spinner });
